import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import Spinner from '@atlaskit/spinner';
import { LARGE, LOADING_CONTENTS_OPACITY } from '../internal/constants';
import { Container, ContentsContainer, SpinnerContainer } from '../styled/LoadingContainer';
export default class LoadingContainer extends React.Component {
  render() {
    const {
      children,
      isLoading,
      spinnerSize,
      contentsOpacity,
      testId
    } = this.props;
    return /*#__PURE__*/React.createElement(Container, null, !isLoading ? children : /*#__PURE__*/React.createElement(ContentsContainer, {
      contentsOpacity: contentsOpacity
    }, children), isLoading && /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(Spinner, {
      size: spinnerSize,
      testId: testId && `${testId}--loadingSpinner`
    })));
  }

}

_defineProperty(LoadingContainer, "defaultProps", {
  isLoading: true,
  spinnerSize: LARGE,
  contentsOpacity: LOADING_CONTENTS_OPACITY
});